import type { CSSProperties, ReactNode } from 'react';

interface EyebrowProps {
  children: ReactNode;
  accent?: boolean;
  tone?: 'default' | 'error';
  className?: string;
  style?: CSSProperties;
}

export default function Eyebrow({
  children,
  accent = false,
  tone = 'default',
  className = '',
  style,
}: EyebrowProps) {
  const toneClass = tone === 'error' ? 'eyebrow-error' : accent ? 'eyebrow-accent' : '';
  return (
    <span className={`eyebrow ${toneClass} ${className}`.trim()} style={style}>
      // {children}
    </span>
  );
}
